import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ArticlesService } from 'src/app/services/articles/articles.service';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';

@Component({
  selector: 'app-artical-details',
  templateUrl: './artical-details.component.html',
  styleUrls: ['./artical-details.component.css'],
})
export class ArticalDetailsComponent {
  article: any;
  articleId: string | null = null;
  constructor(
    private content: ArticlesService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.articleId = params.get('id');
      if (this.articleId) {
        this.loadContent(this.articleId);
      }
    });
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   if (this.articleId) {
    //     this.loadContent(event.lang);
    //   }
    // });
  }
  loadContent(id: string): void {
    this.content.getArticleTranslation(id).subscribe({
      next: (data) => {
        this.article = data;
        if (this.article) {
          this.addMetaTags();
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  addMetaTags() {
    if (this.article && this.article.meta) {
      this.titleService.setTitle(this.article.meta.title);

      this.metaService.updateTag({
        name: 'description',
        content: this.article.meta.description,
      });

      this.metaService.updateTag({
        name: 'keywords',
        content: this.article.meta.keywords,
      });

      this.metaService.updateTag({
        property: 'og:title',
        content: this.article.meta.title,
      });
      this.metaService.updateTag({
        property: 'og:description',
        content: this.article.meta.description,
      });
      this.metaService.updateTag({
        property: 'og:image',
        content: this.article.imageUrl,
      });
    }
  }
}
